import AbstractType from "@/application/typeConfig/AbstractTypeConfig.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";
import router from "@/router/router.ts";
import {Source} from "@/domain/type/source.type.ts";
import {useWorkflowStore} from "@/stores/workflow.store.ts";
import {useSynchroStore} from "@/stores/synchro.store.ts";
import type {StepperItem} from "@/domain/type/config.type.ts";
import type {RouteLocationRaw} from "vue-router";

export default class CompanyConfig extends AbstractType {
  private workflowStore = useWorkflowStore();
  private synchroStore = useSynchroStore()


  cleanFieldValue(value: string, _label: string): string {
    void _label
    return value;
  }

  getStepperItems(): StepperItem[] {
    return [
      {
        disabled: false,
        route: RouteEnum.Fusion,
        icon: "mdi-bank",
        title: "Société",
        action: () => router.push(this.getRoute(RouteEnum.FusionCompany))
      },
      {
        disabled: () => this.disableCollaborators(),
        route: RouteEnum.CompanyUsers,
        icon: "mdi-account-multiple",
        title: "Collaborateurs",
        action: () => router.push(this.getRoute(RouteEnum.CompanyUsers))
      }
    ];
  }

  sourceLeftList(): Source[] {
    return [
      Source.EVA,
      Source.AMMON,
      Source.SIREN
    ];
  }

  sourceRightList(): Source[] {
    return [
      Source.EVA,
      Source.AMMON,
    ];
  }

  private disableCollaborators() {
    if (router.currentRoute.value.name === RouteEnum.FusionCompany) {
      if (this.synchroStore.details?.src1.length === 0) {
        return true
      }
      if (![Source.AMMON, Source.EVA].includes(this.synchroStore.sourceRight)) {
        return true
      }
      if (![Source.AMMON, Source.EVA].includes(this.synchroStore.sourceLeft)) {
        return true
      }
    }
    return false;
  }

  private getRoute(routeName: RouteEnum): RouteLocationRaw {
    switch (routeName) {
      case RouteEnum.FusionCompany:
        return {
          name: RouteEnum.FusionCompany,
          params: {
            sourceLeft: this.synchroStore.sourceLeft,
            sourceRight: this.synchroStore.sourceRight,
            id: this.workflowStore.companyId
          },
          query: {
            _r: Date.now()
          }
        }
      case RouteEnum.CompanyUsers:
        return {
          name: RouteEnum.CompanyUsers,
          params: {
            siret: this.workflowStore.companyId
          },
          query: {
            source: Source.EVA,
            target: Source.AMMON
          }
        }
      default:
        throw new Error(`Unsupported company workflow route: ${routeName}`)
    }
  }
}
